import dayjs from 'dayjs';
import timezone from 'dayjs/plugin/timezone';

import { USER_TIMEZONE } from '../../../utilities/hooks/useDateFormatters';
// ESLint sees a named export and complains about not using it.
// However, when using the named export from Node we get this error:
// ```
// import dayjs, { extend } from 'dayjs';
// SyntaxError: The requested module 'dayjs' does not provide an export named 'extend'
// ```
// We'll just disable the ESLint warning and move on.
// eslint-disable-next-line import/no-named-as-default-member
dayjs.extend(timezone);
dayjs.tz.setDefault(USER_TIMEZONE);
